export default "__VITE_ASSET__Buu9zJtu__"